import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PlatformLocation } from '@angular/common';
import { appConstants } from '../common-service/const.model';
import { SignupService } from '../common-service/signup.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild, ElementRef, Injectable } from '@angular/core';
import { encryptionService } from '../../app/common-service/cedService';
import { PageCountService } from 'src/app/page-count.service';
import { ServerURLService } from '../common-service/serverURL.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UsrmgtService } from '../usermgt/services/usrmgt.service';
import { HttpClient } from '@angular/common/http';
import { IpServiceService } from '../common-service/ip-service.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
declare var grecaptcha: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  errorMsgs: any;
  eyeShow = false;
  captchImage: any;
  getAllRoles: any;
  accessToken: any;
  submitted = false;
  loginFrom: FormGroup;
  showpassword = false;
  public date: any = new Date();
  module:any;
//Add by gokul for google captcha
invalidLogin: boolean = false;
  captchaError: boolean = false;
  loginResponse: string;
  siteKey: string='6LeiApIfAAAAAOBsKqX0U-EQNu3lk3O9LVByiRAA';
  randomSecretKey: any;
  captchaImage: any;
  previewSignsrc: any;
  showPreviewSign: any;
  filePath: string;
  captchaPath: string;
  ipAddress: any;
  ipAddressEncr: any;
  collegeUser: any;
  userDetails: any;
  roleName: any;
  subscribe: Subject<any> = new Subject<any>();
  @ViewChild('myInput') myInputVariable: ElementRef;
  moduleStdReg: boolean = false;

  constructor(public router: Router,public route: ActivatedRoute, public fb: FormBuilder, public toastr: ToastrService,
    public constValues: appConstants, public signin: SignupService, public location: PlatformLocation, 
    public ced: encryptionService,private sessionPageCount : PageCountService, public serverURL: ServerURLService,
    public spinner: NgxSpinnerService, public usrMgtService: UsrmgtService, public http: HttpClient, private ip: IpServiceService) {
    location.onPopState(() => {
      history.forward();
    });
  }

  ngOnInit(): void {
    this.getCaptchaValue();
    // this.sentOTPTest();
    // Login Form
    this.loginFrom = this.fb.group({
      emailId: ['', [Validators.required, Validators.email]],
      passsword: ['', Validators.required],
      captcha:  ['', Validators.required],
    });
    //this.generateCaptcha();
  
    this.errorMsgs = this.constValues.errorMsgs;
  //   setTimeout(() => {
  //    grecaptcha.reset();
  // }, 100);
    if (this.route.snapshot.paramMap.get("module") != null
      && this.route.snapshot.paramMap.get("module") != "NaN") {
        this.route.params.subscribe(params => {
          this.module = params.module;
        });
        if(this.module == 'student') {
          this.moduleStdReg = true;
        } else {
          this.moduleStdReg = false;
        }   
      } else {
        this.moduleStdReg = false;
      } 

      //WEB MVC
      //this.filePath = this.serverURL.apiServerAddress+"dairy-dak/";
      //For session storage clear
      if(sessionStorage.getItem("deleteOauthToken") === "deleteOauthToken") {
        this.clearSession();
      }
  }
  get f() { return this.loginFrom.controls; } // Controls
  
  clearSession() {
    sessionStorage.clear();
    localStorage.clear();
  }

  toCallRecaptha(){
  grecaptcha.reset();
}
  // getRandomKeyGenerator
  getRandomKeyGenerator() {
    this.submitted = true;
    if (this.loginFrom.valid) {
    if (this.loginFrom.value.captcha === this.captchaImage) {
    this.randomSecretKey='';
    this.spinner.show();
    this.signin.getRandomKeyGenerator().subscribe((data: any) => {
     this.randomSecretKey=this.ced.decryptAesformString(data.randamKey, this.serverURL.secretKey);
     this.loginWithIP();
   }, error => {
    console.log(error);
    this.spinner.hide();
    this.getCaptchaValue();
    this.clearSession();
     this.toastr.error('Enter Valid Details', 'Error', {
         timeOut: 3000
       });
     });
    } else {        
      this.spinner.hide();
      this.clearSession();
      this.toastr.error('Enter Valid Captcha', 'Error', {
        timeOut: 3000
      });
    }
    } else {
      this.spinner.hide();
      // this.generateCaptcha();
      grecaptcha.reset();
      this.clearSession();
     }
    }

// Login
login() {
    this.submitted = true;
    if (this.loginFrom.valid) {
      // if (this.loginFrom.value.captch === this.captchImage) {
        const response = grecaptcha.getResponse();
        if (response.length != 0) {
        const obj = {
          emailId: this.ced.encryptAesToString(this.loginFrom.value.emailId, this.randomSecretKey).toString(),
          currentPassword: this.ced.encryptAesToString(this.loginFrom.value.passsword, this.randomSecretKey).toString(),
          recaptchaResponse: response
        };
        this.signin.login(obj).subscribe((loginData: any) => {
          this.spinner.hide();        
        if (loginData.access_token != null) {
            // setTimeout(() => {

              this.ced.encryptingProcess('access-token',this.ced.decryptAesformString(loginData.access_token, this.randomSecretKey));
              this.ced.encryptingProcess('refresh-token',this.ced.decryptAesformString(loginData.refresh_token, this.randomSecretKey));


            // this.ced.encryptingProcess('access-token', loginData.access_token);
            // this.ced.encryptingProcess('refresh-token', loginData.refresh_token);
            this.getLoginUserId();
          
          } else if (loginData.error_description === 'Bad credentials') {
            this.loginFailedAuditLog();
          //  this.generateCaptcha();
          grecaptcha.reset();
            this.toastr.error('Bad credentials', 'Error', {
              timeOut: 3000
            });
          } else {
            this.loginFailedAuditLog();
           // this.generateCaptcha();
           grecaptcha.reset();
           this.clearSession();
            this.toastr.error('User Account is Locked', 'Error', {
              timeOut: 3000
            });
          }
        }, error => {
          this.spinner.hide();
        //  this.generateCaptcha();
        grecaptcha.reset();
        this.clearSession();
          if (error.error == "Invalid captcha") {
            this.toastr.error('Invalid captcha', 'Error', {
              timeOut: 3000
            });
          } else {
            this.toastr.error('Enter Valid Details', 'Error', {
              timeOut: 3000
            });
          }
          this.clearSession();
        });
      } else {
        this.spinner.hide();
        this.captchaError = true;
        this.toastr.error('The g-recaptcha field is Required.', 'Error', {
          timeOut: 3000
        });
      }
    } else {
      this.spinner.hide();
     // this.generateCaptcha();
     grecaptcha.reset();
     this.clearSession();
    }
  }
  // Password Eye Icon
  eyeToggel() {
    this.showpassword = !this.showpassword;
    this.eyeShow = !this.eyeShow;
  }
  // Login User Id
  getLoginUserId() {
    //this.sessionPageCount.pagenumber=undefined;
    this.spinner.show();
    this.signin.getLoginUserId().subscribe((result: any) => {
      this.spinner.hide();
      this.userDetails = result;
     
      if(this.userDetails?.lastName===null){
        this.userDetails.lastName='';
      }
      if(this.userDetails?.middleName===null){
        this.userDetails.middleName='';
      }
      const obj = {
        defaultRole: this.userDetails?.defaultRole,
        rolesList: this.userDetails?.roles,
        useName: this.userDetails?.firstName + ' ' + this.userDetails?.middleName + ' ' + this.userDetails?.lastName,
        deg: this.userDetails?.designation,
        section: this.userDetails?.section,
        userId: this.userDetails?.userId,
        emailId: this.userDetails?.emailId
      };
      this.roleName = this.userDetails?.defaultRole.roleName;
      sessionStorage.setItem('entityId-usec', this.userDetails?.entityMaster?.entityMasterId);
      sessionStorage.setItem('entity-master', this.userDetails?.entityMaster?.name);
      sessionStorage.setItem('userInfo-usec', JSON.stringify(obj));
      sessionStorage.setItem('selectedRole-usec', this.roleName);
      sessionStorage.setItem('fullName-usec', this.userDetails?.fullName);
      sessionStorage.setItem('email-Id', this.userDetails?.emailId);
      sessionStorage.setItem('userId-usec', this.userDetails?.userId);

      if(this.userDetails?.entityMaster !== null) {
        if(this.roleName == 'College Representative') {
          this.getEntityMasterCollegeUser(this.userDetails?.entityMaster?.entityMasterId);
        } else {
          const obj1 = {
            address: this.userDetails?.addresses
          };
          sessionStorage.setItem('entity-college-state', JSON.stringify(obj1));
          sessionStorage.setItem('entity-master', this.userDetails?.entityMaster?.name);
          sessionStorage.setItem('entityId-usec', this.userDetails?.entityMaster?.entityMasterId);

          localStorage.setItem('getSessionStorage', JSON.stringify(sessionStorage));
        }
      } else {
        localStorage.setItem('getSessionStorage', JSON.stringify(sessionStorage));
      }

      this.loginSuccessAuditLog();

      if (this.userDetails?.active === true) {
        if (this.userDetails?.roles !== null) {
          this.getAllRoles = this.userDetails?.roles;
          if (this.roleName === 'System Admin') {
            this.router.navigate(['/main']);
          } else if (this.roleName === 'Accounting_Finance_General') {
            this.router.navigate(['/main/internal/accfinace/dashboard']);
          } else if (this.roleName === 'PTR') {            
            this.router.navigate(['/main/internal/ptr/dashboard/0']);
          } else if (this.roleName === 'SDC') {            
            this.router.navigate(['/main/internal/uidr/dashboard']);
          } else if (this.roleName === 'Dentist') {
            this.router.navigate(['/main/internal/uidr/candidate/uidrList']);
          } else if ((this.roleName !== 'System Admin') &&
            (this.roleName !== 'Accounting_Finance_General')) {              
            this.router.navigate(['/main/internal/dashboard']);
          } else {
            this.toastr.warning('Invalid User', 'Error', {
              timeOut: 3000
            });
          this.getCaptchaValue();
          // grecaptcha.reset();
          this.clearSession();
           }
        }
      } else {
        this.spinner.hide();
        this.toastr.warning('User is Inactive', 'Error', {
          timeOut: 3000
        });
       this.getCaptchaValue();
        //  grecaptcha.reset();
        this.clearSession();
       }
    });

  }

  // Captch Image Executive Committee
  generateCaptcha() {
    const alpha = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O',
      'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd',
      'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's',
      't', 'u', 'v', 'w', 'x', 'y', 'z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0');
    let i;
    for (i = 0; i < 4; i++) {
      var a = alpha[Math.floor(Math.random() * alpha.length)];
      var b = alpha[Math.floor(Math.random() * alpha.length)];
      var c = alpha[Math.floor(Math.random() * alpha.length)];
      var d = alpha[Math.floor(Math.random() * alpha.length)];
      var e = alpha[Math.floor(Math.random() * alpha.length)];
    }
    const code = a + '' + b + '' + '' + c + '' + d + '' + e;
    this.captchImage = code;
  }

  loginSuccessAuditLog() {
    const obj = {
      emailId: this.ced.encryptAesToString(this.loginFrom.value.emailId, this.randomSecretKey).toString(),
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString(),
    }
    this.signin.getSuccessAuditLog(obj).subscribe((result: any) => {
      
    });
  }

  loginFailedAuditLog() {
    const obj = {
      emailId: this.ced.encryptAesToString(this.loginFrom.value.emailId, this.randomSecretKey).toString()
    }
    this.signin.getFailedAuditLog(obj).subscribe((result: any) => {
      
    });
  }

  // loginWithIP() {
    // if(this.serverURL?.apiAddress?.includes('portal.dciindia.gov.in')) {
      // this.http.get<{ip:string}>('https://jsonip.com').subscribe(data => {
      //   console.log('th data', data);
      //   this.ipAddress = data.ip;
      //   this.ipAddressEncr = this.ced.encryptAesToString(this.ipAddress, this.randomSecretKey).toString();
      //   this.loginCaptcha();
      // }, error => {
      //   // this.loginCaptcha();
      //   console.log(error);
      // });  
    // } else {
    //   this.loginCaptcha();
    // }
  // }

  loginWithIP() {  
    this.ip.getIPAddress().subscribe((res:any)=>{  
      console.log('th data', res);
      this.ipAddress=res.ip;  
      this.ipAddressEncr = this.ced.encryptAesToString(this.ipAddress, this.randomSecretKey).toString();
      this.loginCaptcha();
    }, error => {
        console.log(error);
        this.loginCaptcha();
    }); 
  }

  // Login
loginCaptcha() {
    this.submitted = true;
    if (this.loginFrom.valid) {
      if (this.loginFrom.value.captcha === this.captchaImage) {
        if(localStorage !== null && localStorage !== undefined && localStorage.length > 0) {
          if(localStorage.getItem("getSessionStorage") === null) {            
            this.clearSession();
          }
        }        
        if(localStorage !== null && localStorage !== undefined && localStorage.length > 0) {
          this.spinner.hide();  
          var data = JSON.parse(localStorage.getItem("getSessionStorage"));
          for (var key in data) {
            sessionStorage.setItem(key, data[key]);
          }  
          this.router.navigate(['/main/internal/dashboard']);
        } else {
        const obj = {
          emailId: this.ced.encryptAesToString(this.loginFrom.value.emailId, this.randomSecretKey).toString(),
          currentPassword: this.ced.encryptAesToString(this.loginFrom.value.passsword, this.randomSecretKey).toString(),
          captcha: this.loginFrom.value.captcha,
          captchaPath: this.ced.encryptAesToString(this.captchaImage, this.randomSecretKey).toString(),
          ipAddress: this.ipAddressEncr
        };
        console.log(obj);
        this.signin.login(obj).subscribe((loginData: any) => {
          this.spinner.hide();        
        if (loginData.access_token != null) {
             
              this.ced.encryptingProcess('access-token',this.ced.decryptAesformString(loginData.access_token, this.randomSecretKey));
              this.ced.encryptingProcess('refresh-token',this.ced.decryptAesformString(loginData.refresh_token, this.randomSecretKey));
              
            this.getLoginUserId();
                 
          
          } else if (loginData.error_description === 'Bad credentials') {
            this.getCaptchaValue();
            this.loginFailedAuditLog();
            this.toastr.error('Bad credentials', 'Error', {
              timeOut: 3000
            });
          } else if (loginData.error_description === 'Invalid Captcha') {
            //this.getCaptchaValue();
            this.toastr.error('Invalid Captcha', 'Error', {
              timeOut: 3000
            });
          }
           else if(loginData.error_description === 'User InActive') {  
           this.getCaptchaValue();
           this.loginFailedAuditLog();          
           this.clearSession();
            this.toastr.warning('User Account is Locked', 'Error', {
              timeOut: 3000
            });
           }
            else {
            this.getCaptchaValue();
            this.loginFailedAuditLog();
            this.clearSession();
            this.toastr.error('Enter Valid Details', 'Error', {
              timeOut: 3000
            });
          }
        }, error => {
          console.log(error);
          this.spinner.hide();
          this.loginFailedAuditLog();
          this.clearSession();
            this.toastr.error('Enter Valid Details', 'Error', {
              timeOut: 3000
            });
        }); }
      } else {        
        this.spinner.hide();
        this.clearSession();
        this.toastr.error('Enter Valid Captcha', 'Error', {
          timeOut: 3000
        });
      }
      
    } else {
      this.getCaptchaValue();
      this.spinner.hide();
      this.loginFailedAuditLog();
      this.clearSession();
    }
  }
  
  getCaptchaValue() {
    this.usrMgtService.getCaptchaValue().subscribe((result: any) => {
      this.captchaImage = this.ced.decryptAesformString(result?.captcha, this.serverURL.secretKey);
    });
  }

  getEntityMasterCollegeUser(entityMasterId) {
    this.usrMgtService.getEntityMasterByCollegeUser(entityMasterId).pipe(takeUntil(this.subscribe)).subscribe((res: any) => {
      this.collegeUser = res;
      this.userDetails.entityMaster = this.collegeUser;
      sessionStorage.setItem('entity-master', this.collegeUser?.entityMaster?.name);
      sessionStorage.setItem('entityId-usec', this.collegeUser?.entityMaster?.entityMasterId);

      const obj1 = {
        address: this.collegeUser?.address
      };
      sessionStorage.setItem('entity-college-state', JSON.stringify(obj1));
      localStorage.setItem('getSessionStorage', JSON.stringify(sessionStorage));
    }, error => {
      this.spinner.hide();
      console.log(error);
    });
  }

  onEnter(event: KeyboardEvent) {
    // Check if the key pressed is Enter (key code 13)
    if (event.keyCode === 13) {
      // Trigger the login method when Enter is pressed
      this.getRandomKeyGenerator();
    }
  }

}
